// Components
import { Collapse, Nav, Navbar as ReactNavbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from "reactstrap"

// Third-Party Library
import useToggle from "@react-hook/toggle"
import { Link, useNavigate } from "react-router-dom"

// React
import { useState } from "react"

// Icons
import { FaBars } from "react-icons/fa"

// Navigation
import menu from "navigations/rootNav"

const Navbar = ({
  noColorChange = false,
  sticky = "",
  fixed = "",
  baseLink = "",
  logo = ""
}) => {
  // Hooks
  const navigate = useNavigate()
  const [isOpen, toggleNavbar] = useToggle(false, true)

  // States
  const [colorChange, setColorchange] = useState(false)

  const changeNavbarColor = () => {
    if (window.scrollY >= 500) {
      setColorchange(true)
    } else {
      setColorchange(false)
    }
  }
  window.addEventListener('scroll', changeNavbarColor)

  return (
    <ReactNavbar
      style={{ backgroundColor: `rgba(0, 0, 0, ${noColorChange ? '1' : colorChange ? '1' : '0'})` }}
      expand="lg"
      sticky={sticky && "top"}
      fixed={fixed && "top"}
      container
      className="px-2 py-3"
    >
      <NavbarBrand href="#" onClick={() => navigate(`/`, { replace: true })}>
        <img alt="logo" src={logo} style={{ height: 40 }} />
      </NavbarBrand>

      <NavbarToggler onClick={toggleNavbar} style={{ color: 'white' }}>
        <FaBars />
      </NavbarToggler>
      <Collapse isOpen={isOpen} navbar>
        <Nav className="me-auto" navbar />
        <Nav className="ms-auto d-flex align-items-center" navbar>
          {menu.filter(val => val.isMenu && !val.isTitle).map((val, index) => (
            <NavItem key={index} className="mx-50">
              <Link to={`${baseLink}${val.link}`}>
                <NavLink className="text-white">
                  {val.name ?? val.customElement}
                </NavLink>
              </Link>
            </NavItem>
          ))}
        </Nav>
      </Collapse>
    </ReactNavbar>
  )
}

export default Navbar